import { Routes } from "../../methods/ApiRoutes";

const shared = {
  title: 'Notifications',
  addTitle: ' Notification',
  url: 'notification',
  ...Routes.Notification,
};

export default shared;
